function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, i) {
  "function" == typeof define && define.amd ? define(["exports", "jquery"], function (e, s) {
    i(t.bootoast = e, s);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "string" != typeof exports.nodeName ? i(exports, require("jquery")) : i(t.bootoast = {}, t.jQuery);
}(this, function (t, i) {
  "use strict";

  function e(t) {
    if ("string" == typeof t && (t = {
      message: t
    }), "object" == _typeof(t)) {
      this.settings = i.extend({}, this.defaults, t), this.content = this.settings.content || this.settings.text || this.settings.message, this.timeoutProgress = null, this.position = this.positionFor(this.settings.position).split("-"), this.settings.icon = this.settings.icon || this.icons[this.settings.type];
      var e = s + "-container";
      this.containerSelector = "." + e + "." + this.position.join("."), 0 === i("body > " + this.containerSelector).length && i("<div>", {
        class: e + " " + this.position.join(" ")
      }).appendTo("body"), this.$el = i('<div class="' + s + " alert alert-" + this.typeFor(this.settings.type) + '"><span class="glyphicon glyphicon-' + this.settings.icon + '"></span><span class="bootoast-alert-container"><span class="bootoast-alert-content">' + this.content + "</span></span></div>"), this.init();
    }
  }

  if (!i) return console.error("jQuery não encontrado, seu plugin jQuery não irá funcionar."), !1;
  var s = "bootoast";
  return i.extend(e.prototype, {
    defaults: {
      message: "Bootoast!",
      type: "info",
      position: "bottom-center",
      icon: null,
      timeout: 3,
      timeoutProgress: !1,
      animationDuration: 300,
      dismissible: !0
    },
    icons: {
      warning: "exclamation-sign",
      success: "ok-sign",
      danger: "remove-sign",
      info: "info-sign"
    },
    types: ["primary", "secondary", "info", "success", "warning", "danger"],
    typeSinonym: {
      warn: "warning",
      error: "danger"
    },
    positions: ["top-left", "top-center", "top-right", "bottom-left", "bottom-center", "bottom-right"],
    positionSinonym: {
      bottom: "bottom-center",
      leftBottom: "bottom-left",
      rightBottom: "bottom-right",
      top: "top-center",
      rightTop: "top-right",
      leftTop: "top-left"
    },
    init: function init() {
      this.$el[("bottom" === this.position[0] ? "append" : "prepend") + "To"](this.containerSelector);
      var t = this;

      if (!0 === this.settings.dismissible && this.$el.addClass("alert-dismissible").prepend('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>').on("click", "button.close", function (i) {
        i.preventDefault(), t.hide();
      }), this.$el.animate({
        opacity: 1
      }, this.settings.animationDuration), this.settings.timeout) {
        var i = parseInt(1e3 * this.settings.timeout);
        this.hide(i);
      }
    },
    hide: function hide(t) {
      var i = this;
      this.settings.timeoutProgress && this.setTimeoutProgress(this.settings.timeoutProgress);
      var e = setTimeout(function () {
        i.$el.animate({
          opacity: 0
        }, i.settings.animationDuration, function () {
          i.$el.remove();
        });
      }, t || 0);
      return this.$el.hover(clearTimeout.bind(window, e), function () {
        e = i.hide(t);
      }), e;
    },
    setTimeoutProgress: function setTimeoutProgress(t) {
      null !== this.timeoutProgress && this.timeoutProgress.remove();
      var e = {
        top: "prepend",
        bottom: "append"
      },
          s = i("<div>", {
        class: "progress",
        html: i("<div>", {
          class: "progress-bar progress-bar-striped active",
          role: "progressbar",
          "aria-valuemin": 0,
          "aria-valuenow": 0,
          "aria-valuemax": 100
        })
      }),
          o = e[t] || "append",
          n = "string" == typeof e[t] ? t : "background";
      return this.timeoutProgress = s.addClass("progress-" + n)[o + "To"](this.$el), this.timeoutProgress;
    },
    typeFor: function typeFor(t) {
      return this.types[t] ? t : t ? this.typeSinonym[t] || t : "default";
    },
    positionFor: function positionFor(t) {
      if (this.positions[t]) return t;
      var e = i.camelCase(t);
      return this.positionSinonym[e] || "bottom-center";
    },
    moveProgressbar: function moveProgressbar(t, i) {
      var e = 100,
          s = setInterval(function () {
        e <= 0 ? clearInterval(s) : (e--, t.style.width = e + "%");
      }, 100 / i);
      return s;
    }
  }), t.toast = function (t) {
    return new e(t);
  }, t;
});